import { gql, useQuery } from '@apollo/client';

export const GET_OWN_DATA = gql`
  query getOwnData {
    getOwnData {
      _id
      documentsIds
      createdBy
      type
      profile {
        firstName
        lastName
        gender
        companyPhoneNumber
        cityOfBirth
        countryOfBirth
        salutation
        birthName
        phoneNumber
        personalEmail
        birthday
        nationality
        socials {
          linkedIn
          xing
        }
        address {
          zipCode
          country
          city
          street
          houseNumber
        }
        avatarUrl
      }
      account {
        email
        active
        permissionGroup
        permissionGroupId
      }
      employeePersonalInfo {
        status
        internalNumber
        employeeNumber
        preface
        academicDegree
        accessToPlatform
      }
      paymentAndInsurance {
        bankAccountHolder
        iban
        bic
        typeOfVisa
        taxId
        visaExpirationDate
        nationalInsuranceNumber
        healthInsuranceType
        healthInsuranceId
        workPermissionNeeded
        hasCertificateOfStudy
        residencePermissionNeeded
        workPermissionExpireDate
        residencePermissionExpireDate
        certificateOfStudyExpireDate
      }
      emergencyContact {
        name
        phoneNumber
        relationship
        firstAider
        maritalStatus
        childAllowance
      }
      educationAndSkills {
        schoolName
        schoolEducationDescription
        universityName
        universityEducationDescription
        furtherName
        furtherEducationDescription
        trainingName
        trainingDescription
        driversLicenses
        driversLicensesDescription
        highestTrainingDegree
        skills {
          name
          description
        }
      }
      healthInsurance {
        name
        _id
      }
    }
  }
`;

export const useGetOwnData = () => {
  const { data, loading } = useQuery(GET_OWN_DATA);

  const employee = data?.getOwnData || {};

  return { employee, loading };
};
